<script setup>
import { DragDropProvider } from '@dnd-kit/vue'
import { Feedback } from '@dnd-kit/dom'
import { isSortable } from '@dnd-kit/vue/sortable'
import CountryManualSortableDay from './CountryManualSortableDay.vue'

defineProps({
  days: {
    type: Array,
    required: true,
  },
  cdnUrl: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  selectedRookieIds: {
    type: [Array, Set],
    default: () => new Set(),
  },
  selectedRookieDay: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['drag-start', 'reorder', 'drag-end', 'remove', 'select'])

const plugins = (defaults) => [
  ...defaults,
  Feedback.configure({ feedback: 'clone' }),
]

function parseDayFromGroup(group) {
  const day = Number(String(group ?? '').replace(/^day-/, ''))
  return Number.isNaN(day) ? null : day
}

function onDragStart(event) {
  const { source } = event.operation
  if (!source || !isSortable(source)) {
    return
  }
  const day = parseDayFromGroup(source.group)
  if (day == null) {
    return
  }
  emit('drag-start', { day, oldIndex: source.index })
}

function onDragEnd(event) {
  if (event.canceled) {
    emit('drag-end')
    return
  }

  const { source } = event.operation
  if (!source || !isSortable(source)) {
    emit('drag-end')
    return
  }

  const from = source.initialIndex
  const to = source.index
  const day = parseDayFromGroup(source.group)

  if (day != null && from !== to) {
    emit('reorder', { day, from, to })
  }

  emit('drag-end')
}
</script>

<template>
  <DragDropProvider :plugins="plugins" @drag-start="onDragStart" @drag-end="onDragEnd">
    <CountryManualSortableDay
      v-for="day in days"
      :key="day.day"
      :day="day"
      :cdn-url="cdnUrl"
      :loading="loading"
      :selected-rookie-ids="selectedRookieIds"
      :selected-rookie-day="selectedRookieDay"
      @select="$emit('select', $event)"
      @remove="$emit('remove', $event)"
    />
  </DragDropProvider>
</template>
